import {MaintenanceContracts} from 'app/components/entities/maintenance';

export function mapVersion(contract: MaintenanceContracts.Version): string {
  return contract.Release;
}
